import React, { Suspense, lazy, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { useUserContext } from "../../UserContext";
import { canUseCalendarV2, newCalendarPathFor, readCalendarChoice } from "../../calendarV2/calendarV2Access";
import { reservationsApi } from "../../store/reservationsApi";
import { CalendarStoreProvider } from "../../calendar/master";

const CalendarExtremeOptimized = lazy(() =>
   import("../../components/APanel/CalendarExtreme/ACalendarOptimized"),
);

function getExtremePrefetchDate() {
   try {
      const saved = localStorage.getItem("__DV_EXTREME_MONTH");
      if (saved && /^\d{4}-\d{2}$/.test(saved)) {
         const [year, month] = saved.split("-").map(Number);
         return new Date(year, month - 1, 1);
      }
   } catch {}
   return new Date();
}

export default function APOrarExtreme() {
   const dispatch = useDispatch();

   useEffect(() => {
      document.title = "Instruire Auto | Lecții practice EXTREME";
      dispatch(
         reservationsApi.util.prefetch(
            "getReservationsForMonth",
            { date: getExtremePrefetchDate() },
            { force: false },
         ),
      );
   }, [dispatch]);

   // cine a ales calendarul nou ajunge direct acolo (din meniu „Lecții practice”)
   const { user } = useUserContext() || {};
   if (user && canUseCalendarV2(user) && readCalendarChoice(user) === "v2") {
      return <Navigate to={newCalendarPathFor(user)} replace />;
   }

   return (
      <main className="main" style={{ padding: 0 }}>
         <Suspense
            fallback={
               <div className="dayview__loading" role="status" aria-live="polite">
                  <div className="dayview__spinner" />
                  <span>Se încarcă Lecții practice EXTREME...</span>
               </div>
            }
         >
            <CalendarStoreProvider>
               <CalendarExtremeOptimized />
            </CalendarStoreProvider>
         </Suspense>
      </main>
   );
}
